import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { Button, Typography } from "@material-ui/core"
import { DefaultLayout } from "../layouts"
import { Hero, SEO, Section } from "../components"

import BackgroundImage from "gatsby-background-image"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query {
      featuresImage: file(relativePath: { eq: "in_app.jpg" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      integrationsImage: file(relativePath: { eq: "marketplaces.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <DefaultLayout
      style={{
        backgroundImage: `url('blob-shape.svg')`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <SEO title="Home" />
      <Section>
        <Hero
          primaryText="Connect To More Sales Channels On Your Neto Store"
          secondaryText={
            "Kovalt is an integrator that can connect your existing Neto eCommerce Webstore to even more channels"
          }
        />
      </Section>
      <Section style={{ marginBottom: 100 }}>
        <BackgroundImage
          fluid={data.featuresImage.childImageSharp.fluid}
          style={{
            paddingBottom: "51%",
            position: "relative",
            borderRadius: 2,
            boxShadow: `rgba(0, 0, 0, 0.1) 0px 4px 8px 2px, rgba(0, 0, 0, 0.2) 0px 0px 2px`,
          }}
        >
          <Button
            component={Link}
            to="/features"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
            variant="contained"
            color="primary"
          >
            See Features
          </Button>
        </BackgroundImage>
      </Section>
      <Section style={{ maxWidth: 600, minHeight: 300 }}>
        <Typography variant="h2" align="center">
          Connect with these platforms...
        </Typography>
        <Image fluid={data.integrationsImage.childImageSharp.fluid} />
      </Section>
    </DefaultLayout>
  )
}

export default IndexPage
